// extracted by mini-css-extract-plugin
export default {"dashboardMain":"dashboard_dashboardMain__SjAVD","dashboardListWrapper":"dashboard_dashboardListWrapper__rehfB"};